import * as Sentry from '@sentry/react'

export const captureInsecureRedirect = (uri, callback) =>
  Sentry.captureMessage(`Potentially insecure redirect uri: ${uri}`, callback)



// WEBPACK FOOTER //
// ./src/utils/sentry.js